export enum ACTIONS {
    CREATE = 'create',
    READ = 'preview',
    UPDATE = 'update',
    DELETE = 'delete',
    TOGGLE = 'toggle',
}

export const COMPANY_LOGO = 'assets/images/logos/fuse.svg';

export const PARAMS = {
    LIMIT: { LABEL: 'limit', VALUE: '10' },
    OFFSET: { LABEL: 'page', VALUE: '1' },
};

export const HERO_ICONS = 'heroicons_solid:';
export const OUTLINE_ICONS = 'heroicons_outline:';

export const MAT_SVG_ICON = {
    /* SOLID ICONS */
    ADD: `${HERO_ICONS}plus-circle`,
    PLUS_ADD: `${HERO_ICONS}plus`,
    DELETE: `${HERO_ICONS}trash`,
    MAIL: `${HERO_ICONS}envelope`,
    PHONE: `${HERO_ICONS}phone`,
    EYE: `${HERO_ICONS}eye`,
    EYE_OFF: `${HERO_ICONS}eye-slash`,
    ERROR: `${HERO_ICONS}exclamation-circle`,
    USER: `${HERO_ICONS}user`,
    X_CIRCLE: `${HERO_ICONS}x-circle`,
    CLOSE: `${HERO_ICONS}x-mark`,
    ID: `${HERO_ICONS}identification`,
    SERVER: `${HERO_ICONS}server`,
    PLUS: `${HERO_ICONS}plus`,
    ROOM: `${HERO_ICONS}office-building`,
    BED: `${HERO_ICONS}home`,
    CALENDAR: `${HERO_ICONS}calendar`,
    DESCRIPTION: `${HERO_ICONS}document-text`,
    SEARCH: `${HERO_ICONS}search`,
    DATE: `${HERO_ICONS}cake`,
    TRASH: `${HERO_ICONS}trash`,
    CAMERA: `${HERO_ICONS}camera`,
    MORE: `${HERO_ICONS}ellipsis-vertical`,
    TRENDING: `${HERO_ICONS}arrow-trending-down`,
    EXPORT: `${HERO_ICONS}arrow-up-circle`,
    REFUND: `${HERO_ICONS}arrow-uturn-left`,
    PAY: `${HERO_ICONS}currency-dollar`,
    KEY: `${HERO_ICONS}key`,
    CALCULATE: `${HERO_ICONS}calculator`,
    LINK: `${HERO_ICONS}link`,
    CARD: `${HERO_ICONS}credit-card`,
    TAG: `${HERO_ICONS}tag`,
    PORTAL: `${HERO_ICONS}globe-americas`,
    COMPANY: `${HERO_ICONS}briefcase`,
    OFFICE: `${HERO_ICONS}building-office`,
    LOCATION: `${HERO_ICONS}map-pin`,
    BILLING: `${HERO_ICONS}banknotes`,
    PERCENTAGE: `${HERO_ICONS}receipt-percent`,
    CALENDAR_DAY: `${HERO_ICONS}calendar-days`,
    ARROW_UP: `${HERO_ICONS}bars-arrow-up`,
    ARROW_DOWN: `${HERO_ICONS}bars-arrow-down`,
    LEFT: `${HERO_ICONS}chevron-left`,
    RIGHT: `${HERO_ICONS}chevron-right`,

    /* OUTLINE ICONS */
    EYE_OUTLINE: `${OUTLINE_ICONS}eye`,
    QR_OUTLINE: `${OUTLINE_ICONS}qr-code`,
    EDIT_OUTLINE: `${OUTLINE_ICONS}pencil`,
    EXPORT_OUTLINE: `${OUTLINE_ICONS}arrow-up-circle`,
    ADD_OUTLINE: `${OUTLINE_ICONS}plus-circle`,
    LINK_OUTLINE: `${OUTLINE_ICONS}link`,
    BACK_OUTLINE: `${OUTLINE_ICONS}chevron-left`,
    NEXT_OUTLINE: `${OUTLINE_ICONS}chevron-right`,
    CASH_OUTLINE: `${OUTLINE_ICONS}banknotes`,
    WALLET_OUTLINE: `${OUTLINE_ICONS}wallet`,
    UPLOAD_OUTLINE: `${OUTLINE_ICONS}cloud-arrow-up`,
    PHONE_OUTLINE: `${OUTLINE_ICONS}phone`,
    MAIL_OUTLINE: `${OUTLINE_ICONS}envelope`,
    KEY_OUTLINE: `${OUTLINE_ICONS}key`,
    DESCRIPTION_OUTLINE: `${OUTLINE_ICONS}document-text`,
    TAG_OUTLINE: `${OUTLINE_ICONS}tag`,
    ERROR_OUTLINE: `${OUTLINE_ICONS}exclamation-circle`,
    WARNING: `${OUTLINE_ICONS}exclamation-triangle`,
    USER_CIRCLE: `${OUTLINE_ICONS}user-circle`,
    CHECK_CIRCLE: `${OUTLINE_ICONS}check-circle`,
    CHECK_OUTLINE: `${OUTLINE_ICONS}check`,
    SIGN_OUT: `${OUTLINE_ICONS}arrow-right-circle`,
    SECURITY: `${OUTLINE_ICONS}lock-closed`,
    ORIGIN: `${OUTLINE_ICONS}rectangle-group`,
    TREND: `${OUTLINE_ICONS}arrow-trending-up`,
    VIRTUAL_TERMINAL: `${OUTLINE_ICONS}cursor-arrow-rays`,
    ALTERNATIVE: `${OUTLINE_ICONS}currency-dollar`,
    RESERVATION: `${OUTLINE_ICONS}bookmark-square`,
    CURRENCY: `${OUTLINE_ICONS}currency-dollar`,
    CLIPBOARD: `${OUTLINE_ICONS}clipboard-document-list`,
    USER_GROUP: `${OUTLINE_ICONS}user-group`,
    COMPANY_OUTLINE: `${OUTLINE_ICONS}briefcase`,
    BUILDING_OUTLINE: `${OUTLINE_ICONS}building-library`,
    OFFICE_OUTLINE: `${OUTLINE_ICONS}building-office`,
    PORTAL_OUTLINE: `${OUTLINE_ICONS}globe-americas`,
    USER_OUTLINE: `${OUTLINE_ICONS}user`,
    ROLES_OUTLINE: `${OUTLINE_ICONS}arrow-left-on-rectangle`,
    SHIELD: `${OUTLINE_ICONS}shield-check`,
    QUESTION: `${OUTLINE_ICONS}question-mark-circle`,
    COPY: `${OUTLINE_ICONS}document-duplicate`,
    SCALE: `${OUTLINE_ICONS}scale`,
    CARD_OUTLINE: `${OUTLINE_ICONS}credit-card`,
    BILLING_OUTLINE: `${OUTLINE_ICONS}banknotes`,
    INFO: `${OUTLINE_ICONS}information-circle`,
    RECHARGE_OUTLINE: `${OUTLINE_ICONS}arrow-trending-up`,
    INDICATOR: `${OUTLINE_ICONS}presentation-chart-bar`,
    ADMIN: `${OUTLINE_ICONS}circle-stack`,
    INVENTORY: `${OUTLINE_ICONS}archive-box`,
    CATEGORY: `${OUTLINE_ICONS}square-3-stack-3d`,
    SETTINGS_OUTLINE: `${OUTLINE_ICONS}cog-6-tooth`,
};
